import React from "react";
import style from "./index.module.scss";
import NumPad from "./components/NumPad";
import { StuSignIn, StuSignInMap } from "service/signIn";
import StuListSimple from "components/CourseComponents/StuListSimple";

interface NumScreenProps {
    signInId: number;
    code: string;
    refreshTime: number;
    stuSignList: StuSignIn[];
}

export default function NumScreen({
    signInId,
    code,
    stuSignList,
    refreshTime
}: NumScreenProps) {
    function renderStatus({ status }: any) {
        return (
            <span className={style[`status${status}`]}>
                {StuSignInMap[status as keyof typeof StuSignInMap]}
            </span>
        );
    }

    return (
        <div className={style.root}>
            <NumPad signInId={signInId} code={code} refreshTime={refreshTime} />
            <StuListSimple
                data={stuSignList.map(item => ({
                    ...item,
                    studentNo: item.studentno,
                    status: item.signStatus
                }))}
                renderStatus={renderStatus}
            />
        </div>
    );
}
